/**
 * Las reglas del formulario de contacto que se pueden chequear mientras la persona escribe.
 *
 * Son las del servidor (`ContactScreening` en la API), repetidas acá para que el botón de enviar
 * no se habilite con algo que después va a volver rechazado. Si cambian allá, cambian acá.
 */

/** Menos que esto es un saludo y no una consulta: "hola por compra mayoristas". */
export const MINIMO_DEL_MENSAJE = 20;

/**
 * Cuántas letras le faltan al mensaje para llegar al mínimo. Cero si ya llega.
 *
 * Sin los espacios de los bordes, que es como lo cuenta el servidor.
 */
export function faltaParaElMinimo(mensaje: string): number {
  return Math.max(0, MINIMO_DEL_MENSAJE - mensaje.trim().length);
}

/**
 * Si el texto tiene algo para hacer clic: una dirección que empieza con http o con www.
 *
 * No cualquier dominio: "fulltimemotos.com.ar" en un mensaje es un comercio presentándose, y un
 * mail también tiene puntos. Lo que trae el spam es el link.
 */
export function tieneLink(texto: string): boolean {
  return /https?:\/\/|www\./i.test(texto);
}
